export default __webpack_public_path__ + "static/media/menu-header-1.8d413961.png";